import { Injectable } from 'angular2/core';
import { Response } from 'angular2/http';
import { Observable } from 'rxjs/Observable';

import { Resource } from '../api/resource.service';
import { Attendee } from './attendee.model';

@Injectable()
export class AttendeeService {

  constructor(private resource: Resource) { }

  save(attendee: Attendee): Observable<Response> {
    return this.resource.save(attendee);
  }

  get(id: string) : Observable<Response> {
    return this.resource.get(id);
  }

  delete(attendee: Attendee) : Observable<Response> {
    return this.resource.delete(attendee);
  }

  list() : Observable<Response> {
    return this.resource.list();
  }

  register(attendee: Attendee) : Observable<Response> {
    return this.resource.http.noAuth().post('/pub/attendees', JSON.stringify(attendee));
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/attendee/attendee.service.ts
 **/